module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "id": "_idContainer006",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "pl-center"
  }, [_vm._v("Dedicated to my fabulous agent, Michelle Grajkowski, who is always there for meand who never loses faith in me.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("And to my wonderful writer friends who are always willing to help me brainstorm my way out of sticky plot scenarios—Amy, Christopher, Dustin and Renee.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5ae74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 75
// module chunks = 0